import { Component, input } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';

import { TableComponent } from '../../../utils/table/table.component';
import { TableColumnModel } from '../../../../models/table-column.model';
import { AResourceTableComponent } from '../../../AResourceTableComponent';
import { FormGroupHelper } from '../../../../helpers/form-group-helper';

import { VehicleModel } from '../../../../models/resources/vehicle.model';
import { VehicleService } from '../../../../services/resources/vehicle.service';
import { HttpErrorsService } from '../../../../services/utils/http-errors.service';
import { CustomNotificationService } from '../../../../services/utils/custom-notification.service';

@Component({
  selector: 'app-vehicles-table',
  imports: [
    TableComponent,
    ReactiveFormsModule
  ],
  template: `<app-table
    [columns]="tableColumns"
    [data]="models()"
    [filterFormGroup]="filterFormGroup"
    [loading]="resourceService.loading()"
    (doFilterRequest)="resourceService.getAll($event)"
    (urlParamsChange)="this.urlParams = $event"
    [hasActiveFilters]="resourceService.apiResponse().filters != undefined"
    [pagination]="resourceService.paginationMeta()"
    [deleteLoadingIds]="this.deleteLoadingIds()"
    />`,
  styles: ``,
})
export class VehiclesTableComponent extends AResourceTableComponent<VehicleModel> {
  vehicle = input<VehicleModel>();

  filterFormGroup: FormGroup = FormGroupHelper.createFilterFormGroup(this.formBuilder,
    [
      'name',
      'vitabeneEmployee',
      'capacity',
      'location',
    ]
  );

  tableColumns: TableColumnModel[] = [
    {
      name: 'VEHICLES.IS_ACTIVE',
      selector: [{ selector: 'active' }],
      isCheckbox: true
    },
    {
      name: 'VEHICLES.NAME',
      selector: [{ selector: 'name' }],
      filterFormControl: this.filterFormGroup.get('name'),
      filterFormControlLabel: 'VEHICLES.NAME',
      filterUrlParam: 'name',
    },
    {
      name: 'VEHICLES.DESCRIPTION',
      selector: [{ selector: 'description' }],
    },
    {
      name: 'VEHICLES.CAPACITY',
      selector: [{ selector: 'capacity' }],
      filterFormControl: this.filterFormGroup.get('capacity'),
      filterFormControlLabel: 'VEHICLES.CAPACITY',
      filterUrlParam: 'capacity',
    },
    {
      name: 'VEHICLES.EMPLOYEE',
      selector: [{ selector: 'vitabeneEmployee.firstName', suffix: ' ' }, { selector: 'vitabeneEmployee.lastName' }],
      filterFormControl: this.filterFormGroup.get('vitabeneEmployee'),
      filterFormControlLabel: 'VEHICLES.EMPLOYEE',
      filterUrlParam: 'vitabeneEmployee',
    },
    {
      name: 'VEHICLES.LOCATION',
      selector: [{ selector: 'location.name' }],
      filterFormControl: this.filterFormGroup.get('location'),
      filterFormControlLabel: 'VEHICLES.LOCATION',
      filterUrlParam: 'location',
    },

    {
      buttons: [
        {
          iconClass: 'fas fa-external-link-alt fa-lg',
          floating: true,
          outlined: true,
          isObjectLink: true,
          objectBaseLink: '/vehicles'
        },
        {
          iconClass: 'fas fa-trash fa-lg',
          floating: true,
          outlined: true,
          color: 'danger',
          isDelete: true,
          onClick: ($event) => this.delete($event)
        }
      ]
    }
  ]

  constructor(
    formBuilder: FormBuilder,
    public vehicleService: VehicleService,
    httpErrorsService: HttpErrorsService,
    notificationService: CustomNotificationService,
  ) {
    super(formBuilder,
      vehicleService,
      httpErrorsService,
      notificationService,
      'VEHICLES');
  }
}
